import React from "react";
import { Shield, Mail } from "lucide-react";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <div className="flex items-center gap-3 mb-2">
        <Shield className="w-8 h-8 text-[#e86a24]" />
        <h1 className="text-3xl md:text-4xl font-black text-[#1d3d3a]">Informativa Privacy</h1>
      </div>
      <p className="text-sm text-slate-500 mb-8">
        Ultimo aggiornamento: 25 maggio 2026 · Titolare: SAN MARINO MARKET · Conforme al Regolamento (UE) 2016/679 (GDPR)
      </p>

      <div className="prose prose-slate max-w-none space-y-6 text-slate-700">
        <Section title="1. Titolare del trattamento">
          <p>
            Il titolare del trattamento dei dati personali è <strong>SAN MARINO MARKET</strong>, con sede in Città di San Marino (Repubblica di San Marino).
            Per qualsiasi richiesta puoi contattarci all'indirizzo <a href="mailto:privacy@sanmarinomarket.sm" className="text-[#e86a24] font-semibold">privacy@sanmarinomarket.sm</a>.
          </p>
        </Section>

        <Section title="2. Dati raccolti">
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Dati di registrazione:</strong> nome, email, password (cifrata via bcrypt), castello di residenza.</li>
            <li><strong>Dati di accesso Google:</strong> se accedi tramite "Continua con Google", riceviamo email, nome e foto profilo.</li>
            <li><strong>Contenuti pubblicati:</strong> annunci, foto, prezzi, descrizioni, offerte, baratti, puntate d'asta.</li>
            <li><strong>Comunicazioni:</strong> messaggi chat tra utenti (numeri di telefono ed email vengono automaticamente censurati per tutela della tua privacy).</li>
            <li><strong>Dati tecnici:</strong> indirizzo IP, user-agent, log degli accessi, dati per le notifiche push (se attivate).</li>
            <li><strong>Cookie:</strong> solo quelli tecnici essenziali per il funzionamento (token di sessione). Nessun cookie di profilazione di terze parti.</li>
          </ul>
        </Section>

        <Section title="3. Finalità del trattamento">
          <ul className="list-disc pl-6 space-y-1">
            <li>Erogare il servizio di marketplace (pubblicazione annunci, aste, baratti, chat).</li>
            <li>Verificare l'identità e garantire la sicurezza degli account.</li>
            <li>Inviare notifiche transazionali (offerte ricevute, messaggi, esiti aste).</li>
            <li>Adempiere a obblighi di legge e prevenire frodi.</li>
          </ul>
        </Section>

        <Section title="4. Base giuridica">
          <p>
            Esecuzione del contratto (Art. 6.1.b GDPR) per l'uso del servizio. Consenso esplicito (Art. 6.1.a) per le notifiche push e la geolocalizzazione condivisa nella chat.
            Legittimo interesse (Art. 6.1.f) per prevenzione frodi e sicurezza.
          </p>
        </Section>

        <Section title="5. Conservazione dei dati">
          <p>
            I dati sono conservati finché l'account è attivo. Alla cancellazione dell'account, tutti i dati personali, gli annunci, le offerte, i baratti, i messaggi e le iscrizioni alle notifiche vengono eliminati definitivamente entro 30 giorni, salvo obblighi di legge.
          </p>
        </Section>

        <Section title="6. I tuoi diritti (Art. 15-22 GDPR)">
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Accesso e portabilità:</strong> puoi scaricare in qualsiasi momento un export JSON di tutti i tuoi dati dal tuo profilo → "Dati e Privacy".</li>
            <li><strong>Rettifica:</strong> puoi modificare i tuoi dati direttamente dal profilo.</li>
            <li><strong>Cancellazione (oblio):</strong> puoi eliminare il tuo account con un click dal profilo.</li>
            <li><strong>Opposizione e limitazione:</strong> puoi disattivare le notifiche push in qualsiasi momento.</li>
            <li><strong>Reclamo:</strong> hai il diritto di proporre reclamo al Garante della Privacy della Repubblica di San Marino o italiano se applicabile.</li>
          </ul>
        </Section>

        <Section title="7. Trasferimento dati a terzi">
          <p>
            Non vendiamo né cediamo i tuoi dati a terzi. Utilizziamo i seguenti fornitori di servizi tecnici come responsabili del trattamento:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Google Cloud / Mongo Atlas</strong> — hosting database (UE).</li>
            <li><strong>Cloudinary</strong> — hosting CDN delle immagini degli annunci e dei documenti di verifica identità (server UE/USA, conforme Data Processing Addendum GDPR).</li>
            <li><strong>Servizi push browser</strong> (Mozilla, Google FCM, Apple APNS) — per inviare le notifiche se attivate.</li>
            <li><strong>Stripe</strong> — per i pagamenti delle Vetrine Premium, iscrizioni Azienda e degli esiti aste (i dati di pagamento non transitano dai nostri server).</li>
            <li><strong>OpenStreetMap</strong> — per la condivisione della posizione in chat (solo se attivata dall'utente).</li>
          </ul>
        </Section>

        <Section title="8. Sicurezza">
          <p>
            Tutte le password sono salvate cifrate con algoritmo bcrypt. Le comunicazioni avvengono via HTTPS/TLS. I numeri di telefono ed email scritti in chat vengono automaticamente censurati prima del salvataggio.
          </p>
        </Section>

        <Section title="9. Modifiche">
          <p>
            Eventuali modifiche a questa informativa saranno pubblicate su questa pagina con la data di aggiornamento. Le modifiche sostanziali verranno comunicate via email agli utenti registrati.
          </p>
        </Section>

        <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5 flex items-start gap-3 mt-8">
          <Mail className="w-5 h-5 text-[#e86a24] mt-0.5 shrink-0" />
          <div>
            <div className="font-bold text-[#1d3d3a]">Contatti privacy</div>
            <div className="text-sm text-slate-600">Per esercitare i tuoi diritti GDPR scrivi a <a href="mailto:privacy@sanmarinomarket.sm" className="text-[#e86a24] font-semibold">privacy@sanmarinomarket.sm</a>. Rispondiamo entro 30 giorni.</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section data-testid={`privacy-section-${title.split('.')[0]}`}>
      <h2 className="text-xl font-black text-[#1d3d3a] mb-2">{title}</h2>
      <div className="text-sm leading-relaxed">{children}</div>
    </section>
  );
}
